export const ADD_VIEWED_POI = 'SEARCH_CONTEXT/ADD_VIEWED_POI';
export const SET_ACTIVE_POI_IDS = 'SEARCH_CONTEXT/SET_ACTIVE_POI_IDS';
export const SET_BBOX = 'SEARCH_CONTEXT/SET_BBOX';
export const DATA_LAYERS_BBOX_UPDATE = 'SEARCH_CONTEXT/DATA_LAYERS_BBOX_UPDATE';
